import { Button, Modal, Spin } from 'antd';
import React from 'react';

const ThankyouModal = ({
  showModal,
  setShowModal,
  handleClick,
  count,
  loading,
}) => {
  return (
    <div id="delete-levels">
      <Modal
        id="thankyou-modal"
        maskClosable={false}
        centered
        open={showModal}
        footer={null}
        closable={false}
        width={420}
        getContainer={() =>
          // eslint-disable-next-line no-undef
          document.getElementById('delete-levels')
        }
      >
        {loading ? (
          <Spin
            spinning
            className="d-flex justify-center"
            id="thankyou-loading"
          />
        ) : (
          <div id="thankyou-content">
            <h2 id="thankyou-title">Thank you for reviewing.</h2>
            {count > 0 && (
              <p id="remaining-approvals-text">
                You have {count} more approvals pending
              </p>
            )}
            <div className="form-buttons" id="thankyou-buttons">
              <Button
                id="thankyou-okay-button"
                shape="round"
                type="primary"
                className="save-button"
                onClick={() => {
                  handleClick();
                  setShowModal(false);
                }}
              >
                Okay
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ThankyouModal;
